// extracted by mini-css-extract-plugin
export default {"audiocontainer":"audio_audiocontainer__+Act+","audio":"audio_audio__yYBNh","caption":"audio_caption__x-eQC","container":"audio_container__rFLwp"};